var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Call") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.609375,13.78125 C11.1093825,16.6875145 13.3124855,18.8906175 16.21875,20.390625 L18.421875,18.1875 C18.7343766,17.8749984 19.0781231,17.7968742 19.453125,17.953125 C20.5781306,18.3281269 21.7656188,18.515625 23.015625,18.515625 C23.2968764,18.515625 23.5312491,18.6093741 23.71875,18.796875 C23.9062509,18.9843759 24,19.2187486 24,19.5 L24,23.015625 C24,23.2968764 23.9062509,23.5312491 23.71875,23.71875 C23.5312491,23.9062509 23.2968764,24 23.015625,24 C18.3281016,24 14.3203291,22.3359541 10.9921875,19.0078125 C7.66404586,15.6796709 6,11.6718984 6,6.984375 C6,6.70312359 6.09374906,6.46875094 6.28125,6.28125 C6.46875094,6.09374906 6.70312359,6 6.984375,6 L10.5,6 C10.7812514,6 11.0156241,6.09374906 11.203125,6.28125 C11.3906259,6.46875094 11.484375,6.70312359 11.484375,6.984375 C11.484375,8.23438125 11.6718731,9.42186937 12.046875,10.546875 C12.1718756,10.953127 12.0937514,11.2968736 11.8125,11.578125 L9.609375,13.78125 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Call",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Fill",
    fill: "#FFF",
    xlinkHref: "#path-1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.9ea65a83.svg";
export { ForwardRef as ReactComponent };